// Which item a client's report page is "on" — v0.284.0
// ---------------------------------------------------------------------
// Brett: "I thought we could display the favocon at the top of the box if
// they are on?" A link page shows every item at once, so "on" has to be
// chosen: the conversation whose reply box has the cursor (or was just typed
// in) wins; otherwise the conversation box most in view — at least 120 px of
// it, or half of a shorter box, on screen. Two boxes equally in view: the one
// nearer the middle of the screen. Nothing qualifying = on no item (the page
// says nothing rather than guess).
//
//   pickOnItem(boxes: [{ id, top, bottom }], viewH, focusedId?) → id | null
//     top / bottom  the box's edges in viewport px (getBoundingClientRect)
//     focusedId     the item whose reply box has focus, if any

export const ON_ITEM_MIN_PX = 120;

export function pickOnItem(boxes, viewH, focusedId = null) {
  const list = Array.isArray(boxes) ? boxes : [];
  if (focusedId != null && list.some((b) => b && b.id === focusedId)) return focusedId;
  const h = Number(viewH);
  if (!(h > 0)) return null;
  let best = null;
  for (const b of list) {
    if (!b || b.id == null) continue;
    const top = Number(b.top);
    const bottom = Number(b.bottom);
    if (!Number.isFinite(top) || !Number.isFinite(bottom) || bottom <= top) continue;
    const seen = Math.max(0, Math.min(bottom, h) - Math.max(top, 0));
    if (seen < Math.min(ON_ITEM_MIN_PX, (bottom - top) / 2)) continue;
    const off = Math.abs((Math.max(top, 0) + Math.min(bottom, h)) / 2 - h / 2);
    if (!best || seen > best.seen || (seen === best.seen && off < best.off)) best = { id: b.id, seen, off };
  }
  return best ? best.id : null;
}
